exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VerifyAccountPage__text___2FYx6 {\n  font-size: 40px;\n  min-height: 350px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"text": "VerifyAccountPage__text___2FYx6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/VerifyAccountPage/styles/VerifyAccountPage.scss
// module id = 4887
// module chunks = 6